import { Link } from "react-router-dom";
import { Logo } from "@/components/ui/Logo";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="border-t border-border py-12 bg-background">
      <div className="container px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Logo size="sm" className="mb-4" />
            <p className="text-sm text-muted-foreground">
              Operations, simplified.
            </p>
          </div>
          
          <div>
            <div className="font-semibold mb-4 text-sm" role="heading" aria-level={2}>Product</div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/pricing" className="hover:text-foreground transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/#features" className="hover:text-foreground transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/auth" className="hover:text-foreground transition-colors">
                  Get Started
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <div className="font-semibold mb-4 text-sm" role="heading" aria-level={2}>Company</div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/about" className="hover:text-foreground transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-foreground transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <div className="font-semibold mb-4 text-sm" role="heading" aria-level={2}>Legal</div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/legal/privacy" className="hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/terms" className="hover:text-foreground transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/legal/cookies" className="hover:text-foreground transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <div className="font-semibold mb-4 text-sm" role="heading" aria-level={2}>Support</div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="mailto:support@ritual.app" className="hover:text-foreground transition-colors">
                  Help Center
                </a>
              </li>
              <li>
                <a href="mailto:support@ritual.app" className="hover:text-foreground transition-colors">
                  Status
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <span>© {currentYear} Ritual. All rights reserved.</span>
          <span>
            Built by{" "}
            <a
              href="https://bwestudios.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-foreground hover:text-primary transition-colors"
              style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '0.02em' }}
            >
              BWE Studio
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};
